
import React, {Component} from 'react';
import {Button,Modal,ButtonToolbar,FormControl} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
import Select from 'react-select';
import ConfirmPopup from '../../component/element/ConfirmPopup'

var NotificationSystem = require('react-notification-system');

class CarTypeValue extends Component {
  render () {
    return (
			<div className="Select-value" >
				<span className="Select-value-label">
          <span><img src={'https://demo2.bigfix.co/korat/img/'+this.props.value.value+'-32x32.png'}/></span>   
					{this.props.children}
				</span>
			</div>
		);
	}
}

class SWTNewCarTypeButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false,car_type:[],car_type_option:[],showDelete:false,indexDelete:false,icon_options:[]}
  }

  onClick(){
    let that = this
    let {car_type_option} = this.state
    WorkdocStore.loadCarType(function(result) {
      result.icon_options.forEach(function(item,index) {
        car_type_option.push({
          label:item,
          value:item,
        })
      })
      that.setState({show:true,car_type:result.data,car_type_option:car_type_option,icon_options:result.icon_options})
    })
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {name:'',value:'',type:'custom'}
    })
  }

  onSaveClick(e){
    let {car_type,icon_options} = this.state
    
    let postData = {data:car_type}
    WorkdocStore.saveCarType(postData,(result)=> {
      if(result.status ==='OK') {
        this.refs.notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ทำการบันทึกเรียบร้อย',
          level: 'info',
          position: 'tc',        
        })

        if(this.props.onChange!==undefined){
          this.props.onChange(car_type)
        }
      }  
    })
  }

  onHide(){
    this.setState({show:false})
  }

  onConfirmDelete(e) {
    let {indexDelete,car_type} = this.state
    car_type.splice(indexDelete,1)
    this.setState({car_type:car_type,showDelete:false,indexDelete:false})
  }

  onDelete(index,e) {
    this.setState({showDelete:true,indexDelete:index})
  }

  onIconChange(index,e) {
    let {car_type} = this.state
    // let name = ''
    // if (e.value==='SEDAN') {
    //   name = 'รถเก๋ง'
    // } else if (e.value==='PICKUP') {
    //   name = 'รถกระบะ'
    // } else if (e.value==='PICKUPTRUCK') {
    //   name = 'รถกระบะบรรทุก'
    // } else if (e.value==='VAN') {
    //   name = 'รถตู้'
    // } else if (e.value==='MINIVAN') {
    //   name = 'รถตู้แวน'
    // } else if (e.value==='TRUCK') {
    //   name = 'รถบรรทุก'
    // }     

    car_type[index]['value'] = e.value+"-"+index
    // car_type[index]['name'] = name
    this.setState({car_type:car_type})
  }

  renderButton() {
    return(
      <div>
        <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}>
          <FontAwesome name="save" />&nbsp;บันทึก
        </Button>
        <Button className="btn btn-default" onClick={this.onHide.bind(this)}>
          <FontAwesome name="remove" />&nbsp;ปิด
        </Button>
      </div>
    )
  }

  renderTable(){
    return (
      <table className='table table-responsive table-hover table-bordered-solid' style={{marginBottom:'0'}}>
        <thead>
          <tr>
            <th>icon</th>
            <th>ชื่อ</th>
            <th>ลบ?</th>
          </tr>
        </thead>
        <tbody>
        {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderBrandOption(options){
    return (
      <span><img src={'https://demo2.bigfix.co/korat/img/'+options.value+'-32x32.png'}/>{options.value}</span>   
    )
  }

  onTextChange(index,key,e) {
    let {car_type} = this.state
    car_type[index][key] = e.target.value
    this.setState({car_type:car_type})
  }

  getRowClassName(item){
    if(item.type==='system'){
      return 'bg-gray '
    }else{
      return ''
    }
  }

  getCarValue(value){
    let str = value.split("-");
    if(str.length>0){
      return str[0]
    }else{
      return value
    }
  }

  renderRowData() {
    let {car_type,car_type_option} = this.state
    if (car_type===undefined||car_type.length===0) {
      return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        car_type.map((item,index) => {
          return(
            <tr key={index} className={this.getRowClassName(item)}>
              <td>
                <Select
                  disabled={item.type==='system'}
                  clearable={false}
                  optionRenderer={this.renderBrandOption.bind(this)}
                  name="form-field-name"
                  value={this.getCarValue(item.value)}
                  valueComponent={CarTypeValue}
                  options={car_type_option}
                  style={{width:"150px"}}
                  placeholder='เลือกไอคอน'
                  onChange={this.onIconChange.bind(this,index)}
                />
              </td>
              <td>
                <FormControl 
                disabled={item.type==='system'}
                value={item.name} onChange={this.onTextChange.bind(this,index,'name')} />
              </td>
              <td className='text-center'>
                <div style={{display:((item.type==='system')?'none':'')}}>
                  <Button className='btn btn-danger' onClick={this.onDelete.bind(this,index)}><FontAwesome name='eraser' />&nbsp;ลบ</Button>
                </div>
              </td>
            </tr>
          )
        })        
      )
    }
  }

  onRowAdd(number){
    let {car_type} = this.state
    car_type = car_type.concat(this.newEmptyRow(number))
    
    this.pcInput = new Array(car_type.length).fill('')
    this.setState({car_type:car_type})
  }

  renderNewItemButton(){
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>          
        </ButtonToolbar>       
      </div>
    )
  }

  render(){
    let {show,showDelete}  = this.state
    return (
      <div>
        <Button  onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>  
        <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{'เพิ่มประเภทรถ'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {this.renderTable()}
              {this.renderNewItemButton()}            
          </Modal.Body>
          <Modal.Footer>
            {this.renderButton()}
          </Modal.Footer>
        </Modal>
        <ConfirmPopup show={showDelete} 
          title='ยืนยันการทำรายการ' 
          message='ต้องการลบประเภทรถ?'
          confirmTitle='ยืนยันการลบ'
          onConfirm={this.onConfirmDelete.bind(this)}
          onHide={()=>{this.setState({showDelete:false,indexDelete:false})}}        
        />   
        <NotificationSystem ref="notificationSystem" />   
      </div>
    )
  }
}


export default SWTNewCarTypeButton;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewCarTypeButton.js